import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import AppProviders from './components/AppProvider';
import { installServerWakeup } from './utils/serverWakeup';

installServerWakeup();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<AppProviders>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</AppProviders>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
